import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useAppContext } from 'context/AppContext';
import { mustBeNumber } from 'form/validation';
import { convertToNumber, formatAmount } from 'helpers/StringHelper';
import { createEndAdornment } from 'helpers/FormHelper';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Form from 'form/Form';
import { TextField, showErrorOnBlur } from 'mui-rff';

const AddPaymentDialog = ({ purchase, open, onSubmit, onCancel }) => {
    const { appContext } = useAppContext();
    const [initialValues, setInitialValues] = useState(undefined);

    useEffect(() => {
        if(open) {
            setInitialValues({ amount: formatAmount(purchase.amount, purchase.currency, appContext, { skipCurrencySuffix: true, skipThousandSeparators: true }) });
        }
    }, [open]);

    const handleFormSubmit = formValues => {
        onSubmit({
            amount: convertToNumber(formValues.amount)
        });
    };

    return (
        <Dialog maxWidth="md" open={open} onClose={onCancel}>
            <Form
                initialValues={initialValues}
                onSubmit={handleFormSubmit}
            >
                {({ handleSubmit, invalid }) => (
                    <form onSubmit={handleSubmit}>
                        <DialogTitle disableTypography>
                            <Typography variant="h5">
                                Add payment manually
                            </Typography>
                        </DialogTitle>
                        <DialogContent>
                            <Typography variant="body1" gutterBottom>
                                This feature should typically only be used for payments that payment providers are not reporting to the platform. Subscription bookings will be reactivated once all purchased are marked as paid. Use with care.
                            </Typography>

                            <TextField
                                name="amount"
                                label="Amount"
                                variant="outlined"
                                showError={showErrorOnBlur}
                                required
                                fieldProps={{ validate: mustBeNumber }}
                                InputProps={createEndAdornment(purchase.currency)}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={invalid}
                            >
                                Save
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={onCancel}
                            >
                                Cancel
                            </Button>
                        </DialogActions>
                    </form>
                )}
            </Form>
        </Dialog>
    );
};

AddPaymentDialog.propTypes = {
    purchase: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default AddPaymentDialog;
